import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalFunctionsService } from '../services/global-functions.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl?: string;
  response_text: any;
  response_text_error: any;
  response_text2: string;
  response_bad_version: number;
  response_bad_login: number;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService,
      // private alertService: AlertService,
      // public toastr: HotToastService,
      public gfunc:  GlobalFunctionsService,
      vcr: ViewContainerRef,) { 
          // this.toastr.setRootViewContainerRef(vcr);
      }

  ngOnInit(): void {
      // reset login status
     this.authenticationService.logout();


 


      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
      // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/tfa_enter_code';

      // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/tfa/tfa_enter_code';
 
    }



  // need to map ge the results.
  login() {
    console.log('Login Pressed');
      this.loading = true;
      this.authenticationService.login(this.model.username, this.model.password, this.gfunc.app_build)
          .subscribe(
              (data: any) => {

                    // tring to get rid  of blank screen if password is wrong
 
          


// console.log('returnURL: ' + this.returnUrl);

// if(this.gfunc.sessionUserId == null){
//   alert('There seems be the incorrect username or password')
//   this.router.navigate(['/logout']);
//   }
this.response_text = JSON.stringify(data);


                  this.router.navigate([this.returnUrl]);
                  console.log('LoginResponse: ', JSON.stringify(data));

               
             


              },
              (error: any) => {
                  // this.alertService.error(error);
                  console.log('LoginResponse Error: ', JSON.stringify(error.error));

                  this.response_text2 = JSON.stringify(error.error.text);

                  let response_text_error =JSON.parse(this.response_text2);
                  this.response_text_error = response_text_error;

                  if(this.response_text_error.includes('VERSION')){
                    this.response_bad_version = 1;
                  }

                  if(this.response_text_error.includes('YOUR LOGIN CREDENTIALS ARE INCORRECT')){
                    this.response_bad_login = 1;
                  }

                  console.log('error ' + this.response_text_error )
                  
                  // this.toastr.error('Login Failed! Check your details and Try Again.');
                  this.loading = false;
                  // this.authenticationService.logout();
              });
  }










  
}
